const buildScheduleDateQuery = (startTime, endTime) => {
  // UTC dates work with event-api's legacy Date parser without a '+' timezone offset.
  // Leave URL encoding to HttpService to avoid double encoding.
  const start = new Date(startTime || 10000).toUTCString();
  const end = new Date(endTime || Date.now()).toUTCString();
  return `startTime=${start}&endTime=${end}`;
};

export default buildScheduleDateQuery;
